
import { Loader } from '../../../src/js/three.module.js';

//import { OBJLoader            } from '../../../node_modules/three/examples/jsm/loaders/OBJLoader.js'; 
//import { OBJLoader            } from '../../utils/loaders/obj-loader.js'; 

//import { FBXLoader            } from '../../../node_modules/three/examples/jsm/loaders/FBXLoader.js'; 
//import { GLTFLoader           } from '../../../node_modules/three/examples/jsm/loaders/GLTFLoader.js'; 

//import { ColladaLoader        } from '../../../node_modules/three/examples/jsm/loaders/ColladaLoader.js';
//import { ColladaLoader        } from '../../utils/loaders/collada-loader.js';

//import { ObjectLoader } from '../../utils/object-loader.js';

import {
	getOBJLoader,
	getFBXLoader,
	getGLTFLoader,
	getColladaLoader,
	getObjectLoader
} from '../../utils/loaders/loader-manager.js';

const TYPE_OBJ  = "obj";
const TYPE_JSON = "json";
const TYPE_FBX  = "fbx";
const TYPE_GLTF = "gltf";
const TYPE_COLLADA = "collada";

const filenameRegexp1 = /[^/\\&\?]+\.\w{3,4}(?=([\?&].*$|$))/;

function loadFnToAsyncLoadFn( loadFn ) {

	let onProgress = () => {}

	return async function( url ) {

		return await new Promise(( onLoad, onError ) => {

			try {

				loadFn( url, onLoad, onProgress, onError );

			} catch (error) {

				onError( error );

			}
		});
	}
}

const apiGetAttachmentData = ( cache => {
	return async function apiGetAttachmentData( attachment_uid ) {
		
		if (!cache[ attachment_uid ]) {

			cache[ attachment_uid ] = ArtestUserAssets.getAttachment( attachment_uid );

		}

		return await cache[ attachment_uid ];
	}
})({});

export class MeshObjectLoader extends Loader {

	_loaders = {};

	constructor( manager ) {
		super( manager );
	}

	load( url, onLoad = () => {}, onProgress = () => {}, onError = () => {}) {

		let result;

		try {

			result = this.loadUrl( url );

		} catch (error) {
			onError( error );
			return;
		}

		onLoad( result );
	}

	async loadUrl( url, options = {} ) {

		let { type } = options;

		if (!type) type = this.solveTypeByFilename( url );

		if (!type) throw new TypeError( "Can't solve type of attachment" );

		let loader = this.getObjectLoaderByType( type );

		let loadFn = loadFnToAsyncLoadFn(( url, onLoad, onProgress, onError ) => {
			loader.load( url, onLoad, onProgress, onError );
		});

		let result = await loadFn( url );
	
		return this.normalizeResultByType( result, type );
	}

	/**
	 * @param {string} attachment_uid 
	 * @param {object} options 
	 * @returns object
	 */
	async loadAttachment( attachment_uid, options = {} ) {

		let { type } = options;

		let attachment = await apiGetAttachmentData( attachment_uid );

		if (!type) type = this.parseTypeFromAttachment( attachment );

		if (!type) throw new TypeError( "Can't solve type of attachment" );

		let url = this.parseUrlFromAttachment( attachment );

		if (!url) throw new TypeError( "Can't solve url of attachment" );

		return this.loadUrl( url, { ...options, type });
	}

	normalizeResultByType( result, type ) {

		switch (type) {
			
			case TYPE_GLTF:
				return result.scene;
		}

		return result;
	}getObjectLoader

	getObjectLoaderByType( type ) {

		switch (type) {
			case TYPE_OBJ:
				return this._loaders[ TYPE_OBJ ] = this._loaders[ TYPE_OBJ ] || getOBJLoader();

			case TYPE_JSON:
				return this._loaders[ TYPE_JSON ] = this._loaders[ TYPE_JSON ] || getObjectLoader();

			case TYPE_FBX:
				return this._loaders[ TYPE_FBX ] = this._loaders[ TYPE_FBX ] || getFBXLoader();

			case TYPE_GLTF:
				return this._loaders[ TYPE_GLTF ] = this._loaders[ TYPE_GLTF ] || getGLTFLoader();

			case TYPE_COLLADA:
				return this._loaders[ TYPE_COLLADA ] = this._loaders[ TYPE_COLLADA ] || getColladaLoader();
		}

		
		return null;
	}

	solveTypeByMime( mime ) {
	
		switch (mime) {
			case "text/json": return TYPE_JSON;
		}

		return null;
	}

	solveTypeByFilename( filename ) {
		
		let ext = filename.split( '.' ).pop( );

		switch (ext) {
			case "json":  return TYPE_JSON;
			case "obj":   return TYPE_OBJ;
			case "fbx":   return TYPE_FBX;
			case "gltf":  return TYPE_GLTF;
			case "glb":   return TYPE_GLTF;
			case "dae":   return TYPE_COLLADA;
		}

		// Selvitetään onko kyseessä data-url
		let protocol = filename.substring( 0, filename.indexOf( ":" ) );

		if (protocol == "data") {

			let match = /^data:(\w+\/\w+)[;,]/.exec( filename );

			// Ja käytetään mimeä tyypin selvittämiseen
			if (match) return this.solveTypeByMime( match[1] );
		}
		
		return null;
	}

	parseFilenameFromUrl( url ) {

		let match = filenameRegexp1.exec( url );

		if (match) return match[0];

		return null;
	}

	/**
	 * 
	 * @param {object} attachment
	 * @returns {string|null}
	 */
	parseUrlFromAttachment( attachment ) {

		try {

			if (attachment.filename) {
	
				let ext = attachment.filename.substring( attachment.filename.lastIndexOf( "." ));

				if (ext) {
					return "/ajax/attachments/" + attachment.uid + ext;
				}
			}
		} catch (error) {
			console.error( error );
		}

		if (attachment.$downloadUrl) return attachment.$downloadUrl;

		return null;
	}

	/**
	 * function parseTypeFromAttachment
	 * @param {object} attachment
	 * @param {string} attachment.filetype
	 * @param {string} attachment.filename
	 * @returns {string|null} type
	 */
	parseTypeFromAttachment( attachment ) {

		let type = this.solveTypeByMime( attachment.filetype );

		if (!type) type = this.solveTypeByFilename( attachment.filename );

		return type;
	}
}

window.MeshObjectLoader = MeshObjectLoader;